(function () {
  'use strict';
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var form = root.querySelector('form');
    var cards = Array.from(root.querySelectorAll('[data-dc-fbt-card]'));
    var button = root.querySelector('[data-dc-fbt-add]');
    var slider = root.querySelector('.dc-fbt-grid');
    var controls = root.querySelector('[data-dc-fbt-controls]');
    var previous = root.querySelector('[data-dc-fbt-prev]');
    var next = root.querySelector('[data-dc-fbt-next]');
    if (slider && controls) {
      function syncSlider() {
        var max = slider.scrollWidth - slider.clientWidth;
        var position = Math.abs(slider.scrollLeft);
        controls.hidden = max <= 2;
        previous.disabled = position <= 2;
        next.disabled = position >= max - 2;
      }
      function moveSlider(direction) {
        var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
        var step = cards[0].getBoundingClientRect().width + gap;
        var rtl = getComputedStyle(slider).direction === 'rtl' ? -1 : 1;
        slider.scrollBy({ left: direction * step * rtl,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      previous.addEventListener('click', function () { moveSlider(-1); });
      next.addEventListener('click', function () { moveSlider(1); });
      slider.addEventListener('scroll', syncSlider, { passive: true });
      slider.addEventListener('keydown', function (event) {
        if (event.target !== slider) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          var rtl = getComputedStyle(slider).direction === 'rtl';
          moveSlider((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
      });
      if (window.ResizeObserver) new ResizeObserver(syncSlider).observe(slider);
      else window.addEventListener('resize', syncSlider);
      syncSlider();
    }
    var formatter = new Intl.NumberFormat(root.dataset.locale || 'en-GB', {
      style: 'currency', currency: root.dataset.currency || 'GBP'
    });
    function priceMarkup(price, compare) {
      return (compare > price ? '<del>' + formatter.format(compare / 100) + '</del> ' : '') +
        '<span>' + formatter.format(price / 100) + '</span>';
    }
    function update() {
      var total = 0, compareTotal = 0, selected = 0;
      cards.forEach(function (card) {
        var included = card.querySelector('[data-dc-fbt-check]').checked;
        var variant = card.querySelector('[data-dc-fbt-variant]');
        var option = variant.tagName === 'SELECT' ? variant.selectedOptions[0] : variant;
        var price = Number(option.dataset.price);
        var compare = Math.max(price, Number(option.dataset.compare) || price);
        // Recompute from the current selection, including keyboard and touch changes.
        variant.disabled = !included;
        card.querySelector('[data-dc-fbt-quantity]').disabled = !included;
        card.classList.toggle('is-unchecked', !included);
        card.querySelector('[data-dc-fbt-price]').innerHTML = priceMarkup(price, compare);
        if (included) { total += price; compareTotal += compare; selected++; }
      });
      root.querySelector('[data-dc-fbt-total]').innerHTML = priceMarkup(total, compareTotal);
      button.disabled = selected === 0;
    }
    form.addEventListener('change', function (event) {
      if (event.target.matches('select[data-dc-fbt-variant]')) {
        var option = event.target.selectedOptions[0];
        var img = event.target.closest('[data-dc-fbt-card]').querySelector('img');
        if (img && option.dataset.image) {
          img.removeAttribute('srcset');
          img.src = option.dataset.image;
        }
      }
      update();
    });
    // Keep the theme's existing AJAX cart drawer and error handling.
    form.addEventListener('submit', function (event) {
      if (button.disabled) { event.preventDefault(); return; }
    });
    update();
  }
  document.querySelectorAll('[data-dc-fbt]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-dc-fbt]').forEach(init);
  });
})();
